import { REVIEW_STATUS } from "../enums/ReviewStatus";

export const getReviewStatusName = (status) => {
  switch (status) {
    case REVIEW_STATUS.PUBLISHED:
      return "Publicada";
    case REVIEW_STATUS.BANNED:
      return "Banneada";
    default:
      return "";
  }
};
